import { render, staticRenderFns } from "./ContentEditableV3.vue?vue&type=template&id=9e6b0460"
import script from "./ContentEditableV3.vue?vue&type=script&lang=js"
export * from "./ContentEditableV3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports